"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ConfirmationDialog = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ConfirmationDialog, _React$PureComponent);

  var _super = _createSuper(ConfirmationDialog);

  function ConfirmationDialog() {
    var _this;

    (0, _classCallCheck2.default)(this, ConfirmationDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClose", function (yes) {
      if (_this.props.onClose) {
        _this.props.onClose(yes);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(ConfirmationDialog, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          text = _this$props.text,
          open = _this$props.open,
          alert = _this$props.alert;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Dialog.default, {
        open: open,
        onClose: function onClose() {
          return _this2.handleClose(false);
        },
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
      }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
        id: "alert-dialog-title"
      }, title ? title : ''), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
        id: "alert-dialog-description"
      }, text)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, alert ? null : /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: function onClick() {
          return _this2.handleClose(false);
        },
        color: "primary"
      }, "No"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        onClick: function onClick() {
          return _this2.handleClose(true);
        },
        color: "primary",
        autoFocus: true
      }, alert ? 'OK' : 'Yes'))));
    }
  }]);
  return ConfirmationDialog;
}(_react.default.PureComponent);

exports.default = ConfirmationDialog;